import type { PropsWithChildren } from 'react';
import classnames from 'classnames';
import { LiraAdvContainer } from '@sbt-web/adv';
/* eslint-disable import/order */
import styles from './index.module.scss';
import gridStyles from '@/client/components/Detail/Containers/style/grid.module.scss';

interface Props {
  skyscraperLeft?: {
    id: string;
    enabled: boolean;
  };
  skyscraperRight?: {
    id: string;
    enabled: boolean;
  };
  billboard?: {
    id: string;
    enabled: boolean;
  };
}

const SkeletonWithAdv = ({
  children,
  skyscraperLeft,
  skyscraperRight,
  billboard,
}: Props & PropsWithChildren) => {
  return (
    <div className={styles['skeleton']}>
      {skyscraperLeft?.enabled ? (
        <aside className={styles['left-aside']}>
          <div className={styles['aside-wrapper']}>
            <div className={styles['aside-skyscraper']}>
              <div id={skyscraperLeft.id} />
            </div>
          </div>
        </aside>
      ) : null}

      <div className={styles['main']}>
        {billboard?.enabled && (
          <div className={styles['billboard']}>
            <LiraAdvContainer
              className={classnames(
                gridStyles['detail-component'],
                styles.adviewTop,
              )}
              style={{
                height: `250px`,
                alignContent: 'center',
              }}
              withPlaceholder
              idForAd={billboard.id}
            />
          </div>
        )}
        {children}
      </div>

      {skyscraperRight?.enabled ? (
        <aside className={styles['right-aside']}>
          <div className={styles['aside-wrapper']}>
            <div className={styles['aside-skyscraper']}>
              <div id={skyscraperRight.id} />
            </div>
          </div>
        </aside>
      ) : null}
    </div>
  );
};

export { SkeletonWithAdv };
